export enum TrialCreationAmplitudeEvent {
  TRIAL_STARTED = "trial_started",
  TRIAL_DESIGN_CONFIGURED = "trial_design_configured",
  TRIAL_RATES_FINALIZE = "trial_rates_finalize",
  TRIAL_STATUS_TOGGLE = "trial_status_toggle",
  TRIAL_ACTION_CLICK = "trial_action_click",
  TRIAL_FILTER = "trial_filter",
  TRIAL_PREVIEW = "trial_preview",
}

export enum TrialReportingAmplitudeEvent {
  TRIAL_REPORT_GENERATE = "trial_report_generate",
  TRIAL_REPORT_SHARE = "trial_report_share",
  TRIAL_REPORT_VIEW = "trial_report_view",
}

export enum ProtocolCreationAmplitudeEvent {
  PROTOCOL_CREATION_STARTED = "protocol_creation_started",
  PROTOCOL_TYPE_SELECTED = "protocol_type_selected",
  PROTOCOL_RULES_SAVED = "protocol_rules_saved",
  PROTOCOL_PRODUCT_ADDED = "protocol_product_added",
  PROTOCOL_NUTRIENT_SET = "protocol_nutrient_set",
  PROTOCOL_PUBLISHED = "protocol_published",
  PROTOCOL_ACTION_CLICKED = "protocol_action_clicked",
  PROTOCOL_FILTER = "protocol_filter",
  PROTOCOL_PREVIEW = "protocol_preview",
}

export enum NavigationEvents {
  SUMMARY_VIEWED = "summary_viewed",
  YIELD_ANALYSIS = "yield_analysis",
}

export enum ExportEvents {
  TRIAL_DATA_EXPORTED = "trial_data_exported",
}

export enum ProtocolTemplatesAmplitudeEvent {
  SAVE_AS_TEMPLATE_WORKSPACE_UNIVERSAL = "Save as template (universal / workspace)",
  SAVE_AS_TEMPLATE_WORKSPACE = "Save as Template (workspace)",
  SAVE_AS_TEMPLATE_UNIVERSAL = "Save as Template (universal)",
  DELETE_TEMPLATE = "Delete Template",
  USE_TEMPLATE = "Use Template",
}
